module.exports = __webpack_public_path__ + "static/media/wallet-dark-bgr.d6bbc298.png";